import ButtonSp from '../ui/ButtonSp'
import { Container, makeStyles, useMediaQuery, useTheme } from '@material-ui/core'
import { useTranslation } from 'next-i18next'

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.homeStyle.section,
    padding: `${theme.spacing(5)}px ${theme.spacing(0)}px`,
    textAlign: 'center',
    backgroundColor: theme.palette.primary.main,
    '& h1': {
      ...theme.homeStyle.title,
      margin: `0 0 ${theme.spacing(3)}px`,
      color: 'white',
      [theme.breakpoints.down('xs')]: {
        marginBottom: theme.spacing(1),
      }
    },
    '& h2': {
      ...theme.homeStyle.subtitle,
      margin: `0 0 ${theme.spacing(4)}px`,
      color: 'white'
    }
  },
  button: {
    ...theme.homeStyle.button,
    backgroundColor: 'white !important',
  },
}))

const GetStarted = () => {

  const classes = useStyles()
  const { t } = useTranslation('common')
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  return (
    <div
      className={classes.root}
    >
      <Container>
        <h1>{t('get-started.title')}</h1>
        <h2>{t('get-started.sub')}</h2>
        <ButtonSp
          variant="outlined"
          className={classes.button}
          fullWidth={isMobile}
          component="a"
          href="https://m.me/shippop"
          target="_blank"
        >
          {t('get-started.chat-with-us')}
        </ButtonSp>
      </Container>
    </div>
  )
}

export default GetStarted
